import styled from 'styled-components/macro';
import Flex from 'styled-flex-component';
import { variables } from 'theme/variables';

const {
  custom_blue: customBlue,
  color_blue_700: colorBlue700,
  color_white: colorWhite,
  custom_dark_grey: customDarkGrey,
} = variables;

export const ElementBlock = styled('div')`
  background-color: ${(props) =>
    props.elementNumber < 17 ? customBlue : colorBlue700};
  color: ${colorWhite};
  min-width: ${(props) => props.minWidth};
  height: ${(props) => 100 / props.elements.length - 1}%;
  width: 170%;
  margin-left: 3px;
  padding: 10px 15px 3px;
  border-radius: 0.2em;
  .symbol {
    font-size: 1.5em;
  }
  .at_num {
    font-size: 0.5em;
    align-self: flex-start;
  }
  .elem_name {
    padding-top: 0.2em;
    font-size: 0.8em;
  }
  .range {
    padding-top: 0.7em;
    font-size: 0.7em;
  }
  @media (max-width: 768px) {
    .symbol {
      font-size: 1.3em;
    }
    .elem_name {
      font-size: 0.5em;
    }
    .range {
      font-size: 0.45em;
    }
  }
  @media (max-width: 425px) {
    height: 80px;
    padding-left: 12px;
    .symbol {
      font-size: 1em;
    }
    .elem_name {
      font-size: 0.45em;
    }
    .range {
      font-size: 0.48em;
    }
  }
`;

export const AlloyDetails = styled(Flex)`
  padding-top: ${(props) => (props.listingsRefactor ? '40px' : '0')};
  padding-left: ${(props) => (props.listingsRefactor ? '40px' : '0')};
  padding-right: ${(props) => (props.listingsRefactor ? '25px' : '0')};
  .alloyDataRow {
    display: flex;
    flex-wrap: wrap;
  }
  .alloyDataCol {
    margin-bottom: 30px;
    padding-right: 70px;
  }
  .lastAlloyDataCol {
    margin-bottom: 80px;
    margin-top: -15px;
    font-weight: 800;
  }
  .dataSheetButton {
    margin-top: 10px;
    margin-left: 40%;
    padding: 10px 80px;
    min-width: 90%;
    max-width: 100%;
    font-size: 16px;
    box-shadow: 1px 1px 7px -2px ${customDarkGrey};
  }
  .elemCol {
    max-width: 100%;
    margin-bottom: 30px;
  }
  @media (max-width: 1330px) {
    .dataSheetButton {
      margin-left: 10%;
    }
  }
  @media (max-width: 1200px) {
    .elemCol {
      max-width: 100%;
    }
  }
  @media (max-width: 767px) {
    .alloyDataRow {
      display: flex;
      flex-flow: column wrap;
    }
    .alloyDataCol {
      margin-bottom: 5px;
    }
    .lastAlloyDataCol {
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
      margin-bottom: 20px;
      justify-content: center;
    }
    .dataSheetButton {
      margin-left: 0;
    }
  }
  @media (max-width: 767px) {
    padding-right: ${(props) => (props.listingsRefactor ? '11px' : '0')};
  }
  @media (max-width: 425px) {
    padding-top: ${(props) => (props.listingsRefactor ? '20px' : '0')};
    padding-left: ${(props) => (props.listingsRefactor ? '20px' : '0')};
    .dataSheetButton {
      padding: 10px 40px;
    }
  }
`;
